<template>
  <div ref="whole_page" id="quiz-results-view">

    <canvas v-show="isCardActive" id="canvas" style="position: absolute;"></canvas>

    <vs-button v-if="isCardActive" id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather"
    style="position: fixed !important; bottom: 3% !important; z-index: 2;" 
    icon="icon-help-circle" />
    
    <div v-show="isCardActive">
      <div>
        <div class="vx-row">
          <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-full xl:w-1/3 w-full"></div>
            <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-full xl:w-1/3 w-full centereverything">
              <h3>Quiz Review</h3>
            </div>
        </div>

        <div class="vx-row" v-if="quizResponse.achievedPercentage != 0">
          <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-full xl:w-1/3 w-full"></div>
            <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-full xl:w-1/3 w-full">

              <div class="wrapper">
                <div class="container chart" data-size="250" data-arrow="up">
                </div>
              </div>

            </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <!-- <div class="flex flex-wrap items-center justify-center pb-2">
              <div v-show="quizResponse.finalResult == 'Pass'" class="final-result pass">
                <p><strong>{{ quizResponse.finalResult }}ed</strong></p>
              </div>
              <div v-show="quizResponse.finalResult == 'Fail'" class="final-result fail">
                <p><strong>{{ quizResponse.finalResult }}ed</strong></p>
              </div>
            </div> -->
            <div v-if="quizResponse.marksScored > 0 && quizResponse.quizTotal > 0">
              <div class="marks flex flex-wrap items-center justify-center pb-1">
                <p><strong>Marks: {{ quizResponse.marksScored }}/{{ quizResponse.quizTotal }}
                  <!-- <span style="color: red">**</span> ({{ Math.round(((quizResponse.achievedPercentage + 0.00001)) / 1000) * 100 }}%) -->
                </strong></p>
              </div>
              <div class="flex flex-wrap items-center justify-center p-2">
                <p><small>Free text & table questions will be reviewed by an Assessor.</small></p>
              </div>
              <div class="flex flex-wrap items-center justify-center p-2">
                <p style="color: red"><small><strong>**Please note that your score may change based on the results from your free text and/or table answers.</strong></small></p>
              </div>
            </div>
            <div v-else>
              <div class="flex flex-wrap items-center justify-center p-2">
                <p style="font-size:13pt">Free text & table questions will be reviewed by an Assessor.</p>
              </div>
              <div class="flex flex-wrap items-center justify-center p-2">
                <p style="font-size:13pt"><strong>Please note that your score may change based on the results from your free text and/or table answers.</strong></p>
              </div>
            </div>
            <div v-show="isTimeUpLabelShown">
              <div class="flex flex-wrap items-center justify-center">
                <p style="color: red"><strong>Your time is up!</strong></p>
              </div>
            </div>
            <div v-show="quizFailed">
              <div class="flex flex-wrap items-center justify-center">
                <p style="color: red">You needed at least<strong> {{ quizResponse.passPercentage }}% </strong>to pass.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-divider>Results</vs-divider>
          </div>
        </div>
        <div>
          <ul>
            <li v-for="(question, index) in quizResponse.answers" :key="index">
              <div>
                <div class="vx-row pb-3">
                  <div class="vx-col w-full">
                    <vx-card :style="{'padding':'0px !important', 'background-color': question.questionType == 6 ? 'rgba(255, 204, 0, 0.3)' : question.questionType == 4 ? 'rgba(255, 204, 0, 0.3)' : question.questionType == 3 ? 'rgba(255, 204, 0, 0.3)' : question.questionAchievedMarks == question.questionTotalMarks ? 'rgba(107, 255, 81, 0.3)' : question.questionAchievedMarks < question.questionTotalMarks && question.questionAchievedMarks != 0 ? 'rgba(255, 204, 0, 0.3)' : 'rgba(255, 56, 56, 0.3)' }">
                      <div class="vx-row">
                        <div class="vx-col w-full mb-2">
                          <h4>{{question.questionTitle }}</h4>
                        </div>
                      </div>
                      <div class="vx-row">
                        <div class="vx-col mb-2" style="overflow-wrap: break-word; word-break: break-word;">
                          <div id="question-text-div" v-html="question.questionText"></div>
                        </div>
                        <vs-spacer></vs-spacer>
                        <div class="vx-col mb-2">
                          <div v-if="question.questionTotalMarks > 0">
                            <p>{{ question.questionAchievedMarks }} / {{ question.questionTotalMarks }} ({{ question.questionAchievedMarks != question.questionTotalMarks ? (((question.questionAchievedMarks + 0.00001) / question.questionTotalMarks) * 100).toFixed(2) : (((question.questionAchievedMarks + 0.00001) / question.questionTotalMarks) * 100).toFixed(0) }}%)</p>
                          </div>
                        </div>
                      </div>
                      <div class="vx-row">
                        <div class="vx-col w-full mb-2">
                          <div v-show="question.questionType == 1">
                            <ul>
                              <li v-for="(option, index) in question.options" :key="index">
                                <div class="vx-row">
                                  <div class="vx-col w-full" style="overflow-wrap: break-word; word-break: break-word;">
                                    <vs-radio :disabled="true" v-show="option.optionNumber != (question.inputAnswer? parseInt(question.inputAnswer.replace(/<[^>]*>?/gm, '')) : question.inputAnswer) " v-model="trueValue" :vs-value="true">
                                      <div>
                                        <ul class="flex items-center justify-center">
                                          <li>
                                            {{ option.optionNumber }}.
                                          </li>
                                          <li class="ml-2 resizequillimage " v-html="option.optionText">
                                          </li>
                                        </ul>
                                      </div>
                                    </vs-radio>
                                    <vs-radio :disabled="true" v-show="option.optionNumber == (question.inputAnswer? parseInt(question.inputAnswer.replace(/<[^>]*>?/gm, '')) : question.inputAnswer)">
                                      <div>
                                        <ul class="flex items-center justify-center">
                                          <li>
                                            {{ option.optionNumber }}.
                                          </li>
                                          <li class="ml-2 resizequillimage" v-html="option.optionText">
                                          </li>
                                        </ul>
                                      </div>
                                    </vs-radio>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div v-show="question.questionType == 2">
                            <ul>
                              <li v-for="(option, index) in question.options" :key="index">
                                <div class="vx-row mb-2">
                                  <div class="vx-col w-full" style="overflow-wrap: break-word; word-break: break-word;">
                                    <vs-checkbox :disabled="true" v-model="option.isSelected" style="padding:5px">
                                      <div>
                                        <ul class="flex items-center justify-center">
                                          <li>
                                            {{ option.optionNumber }}.
                                          </li>
                                          <li class="ml-2 resizequillimage" v-html="option.optionText">
                                          </li>
                                        </ul>
                                      </div>
                                    </vs-checkbox>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div v-show="question.questionType == 3" class="free-text-answer">
                            <vs-card readOnly=true id="review-answer" v-html="question.inputAnswer"></vs-card>
                          </div>
                          <div v-show="question.questionType == 4">
                            <ag-grid-vue
                              ref="agGridTable" 
                              :gridOptions="gridOptions"
                              class="ag-theme-material w-100 my-4 ag-grid-table"
                              :columnDefs="  quizResponse.answers[index].tableColumns"
                              :rowData="quizResponse.answers[index].tableRows"
                              :defaultColDef="defaultColDef"
                              colResizeDefault="shift"
                              :domLayout="'autoHeight'"
                              :animateRows="true"
                              @resize="resizeCard">
                            </ag-grid-vue>
                            <span class="table-swipe-label centereverything w-full" style="margin-top: -4rem !important;padding-bottom: 2rem;"><small>Swipe to see more</small><feather-icon class="pl-2" icon="ArrowRightIcon" svg-classes="stroke-current h-3 w-3"></feather-icon></span>
                          </div>

                          <div v-show="question.questionType == 5">
                            <div class="draggable-images-quiz-result">
                              <div v-for="(location, index) in question.dragAndDropMapLocations" :key="index">
                                <img :style="(location.xCoordinate == location.selectedXCoordinate) && (location.yCoordinate == location.selectedYCoordinate) 
                                                ? 'box-shadow: 1px 1px 1px 1px #28C76F;' : 'box-shadow: 1px 1px 1px 1px #EA5455;'" 
                                                :src="location.draggableImageUrl" style="width: 50px">
                                <div v-if="(location.xCoordinate == location.selectedXCoordinate) && (location.yCoordinate == location.selectedYCoordinate)">
                                  Correct
                                </div>
                                <div v-else>
                                  Wrong
                                </div>
                              </div>
                            </div>
                          </div>

                          <div v-show="question.questionType == 6" >
                            <vx-card title="Uploaded Files" class="w-full mb-6">
                              <div v-for="(file,fileIndex) in checkforArray(question.uploadedFile)" :key="fileIndex">
                                <div class="ml-2 vx-row w-full mb-2">
                                  <vs-button  color="success" class="vx-col" type="filled" icon-pack="feather" icon="icon-download" @click.stop="downloadFile(file)"></vs-button>
                                  <p class="ml-2" style="align-self:center;">{{fileName(file)}}</p>
                                </div>
                              </div>
                            </vx-card>
                          </div>
                        </div>
                      </div>
                    </vx-card>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- <img id="next-task-arrow" @click="nextTask()" v-show="isCardActive && !isStudentProp && !styleB" src="../../assets/images/digi-next-arrow.png"/> -->
      </div>
    </div>

    <div class="flex next_btns__container justify-center">
      <vs-button v-show="isCardActive && $route.name != 'DigiStudentProfile'" :id=" styleB ? 'completetask-btn' : 'nexttask-btn'" class="vs-con-loading__container next_btns clickbuttonactive" 
      ref="submit_btn" icon-pack="feather" icon="icon-arrow-right" icon-after
      @click="nextTask()">
      {{ styleB ? 'Complete' : 'Next Task' }}
      </vs-button>
    </div>

    <vs-popup title="Having some problems?" :active.sync="helpPopupActive">
      <p class="pb-2">Please tell us about the issues you are experiencing:</p>
      <vs-textarea v-model="errorData.userMessage" />
      <p class="pb-2">Your WhatsApp number:</p>
      <vs-input autocomplete="off" v-validate="'digits:10'" name="WhatsApp number" v-model="errorData.whatsappNumber" />
      <span class="text-danger text-sm" v-show="errors.has('WhatsApp number')">{{ errors.first('WhatsApp number') }}</span>
      <div class="mt-3">
        <vs-button color="success" class="float-right" @click="submitIssue">Submit</vs-button>
      </div>
    </vs-popup>

  </div>
</template>

<script>
  import { setInterval } from 'timers';
  import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss';
  import { AgGridVue } from 'ag-grid-vue';
  import VueApexCharts from 'vue-apexcharts';
  import confetti from 'canvas-confetti';

  export default {
    components: {
      AgGridVue,
      VueApexCharts
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      quizResponse: {
        type: Object,
        required: false
      },
      cardHeight: {
        type: Number,
        required: false,
      },
      cardWidth: {
        type: Number,
        required: false,
      },
      isStudentProp: {
        type: Boolean,
        required: false
      },
      errorDataProp: {
        type: Object,
        required: false
      },
      taskIdProp: {
        type: Number,
        required: false,
      },
      moduleId: {
        type: Number,
        required: false,
      },
      styleB: {
        type: Boolean,
        required: false
      },
    },
    data() {
      return {
        isTimeUpLabelShown: false,
        quizFailed: false,
        trueValue: "true",
        gridApi: null,
        gridOptions: {},
        defaultColDef: {
          sortable: false,
          editable: true,
          resizable: true,
          suppressMenu: true
        },
        helpPopupActive: false,
        errorData: {
          userId: null,
          taskId: null,
          userMessage: "",
          osName: "",
          osVersion: "",
          browserName: "",
          browserVersion: "",
          navigatorUserAgent: "",
          navigatorAppVersion: "",
          navigatorPlatform: "",
          navigatorVendor: "",
          isMobile: false,
          whatsappNumber: ""
        },
      }
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;

          self.quizFailed = false;
          self.isTimeUpLabelShown = false;

          if(self.quizResponse.finalResult == "Fail")
            self.quizFailed = true;

          if(self.quizResponse.timeUp == 1){
            self.isTimeUpLabelShown = true;
          }
          
          if(self.gridApi)
            self.gridApi.sizeColumnsToFit();

          self.chartFunction();

          if(!self.quizFailed){
            var dimension = [document.documentElement.clientWidth, document.documentElement.clientHeight];
            var c = document.getElementById("canvas");
            c.width = dimension[0];
            c.height = dimension[1];

            self.showMyConfetti();
          }
        }
      }
    },
    methods: {
      nextTask() {
        var self = this;
        if(self.styleB){
          var timeCapture = null;
          if (self.$route.query.timeCapture) {
            timeCapture = JSON.parse(self.$route.query.timeCapture);
          }
          if (self.$route.query.outcome) {
            self.$router.push({ name: self.$route.query.ref == 'public' ? "PublicOutcomeTasks" : "Gen2OutcomeTasks", query: { moduleId: self.$route.params.moduleId, lpName: self.$route.query.lpName, lpNumber: self.$route.query.lpNumber, selectedTaskGroup: self.$route.query.selectedTaskGroup, selectedOutcome: self.$route.query.selectedOutcome, timeCapture: JSON.stringify(timeCapture) }});
          } else {
            if(self.$route.params.styleB)
              self.$router.push({ name: 'LearningStyleBViewer', params: { moduleId: self.$route.params.moduleId, checkTimeCapture: true }})
            else
              self.$router.push('/menu');
          }
        }
        else {
          this.$emit("nextTask");
        }
      }, 
      submitIssue() {
        var self = this;
        self.helpPopupActive = false;

        self.errorData.osName = self.errorDataProp.osName;
        self.errorData.osVersion = self.errorDataProp.osVersion;
        self.errorData.browserName = self.errorDataProp.browserName;
        self.errorData.browserVersion = self.errorDataProp.browserVersion;
        self.errorData.navigatorUserAgent = self.errorDataProp.navigatorUserAgent;
        self.errorData.navigatorAppVersion = self.errorDataProp.navigatorAppVersion;
        self.errorData.navigatorPlatform = self.errorDataProp.navigatorPlatform;
        self.errorData.navigatorVendor = self.errorDataProp.navigatorVendor;

        self.errorData.taskId = self.taskIdProp;
        self.errorData.isMobile = self.isMobile();
        
        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Issue submitted!",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-check'
          });
        };

        self.$ajaxPost(self, "Student/LogError", self.errorData, onSuccess);
      },
      chartFunction(){
        var existingGraph = document.getElementById("score_graph");
        if (existingGraph) {
          existingGraph.remove();
        }

        var showPers = this.quizResponse.achievedPercentage;
        var Dial = function(container) {
            this.container = container;
            this.size = this.container.dataset.size;
            this.strokeWidth = this.size / 8;
            this.radius = (this.size / 2) - (this.strokeWidth / 2);
            this.value = showPers;
            this.direction = this.container.dataset.arrow;
            this.svg;
            this.defs;
            this.slice;
            this.overlay;
            this.text;
            this.arrow;
            this.create();
        }

        Dial.prototype.create = function() {
            this.createSvg();
            this.createDefs();
            this.createSlice();
            this.createOverlay();
            this.createText();
            this.createArrow();
            this.container.appendChild(this.svg);
        };

        Dial.prototype.createSvg = function() {
            var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute('id', 'score_graph');
            svg.setAttribute('width', this.size + 'px');
            svg.setAttribute('height', this.size + 'px');
            this.svg = svg;
        };

        Dial.prototype.createDefs = function() {
            var defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
            var linearGradient = document.createElementNS("http://www.w3.org/2000/svg", "linearGradient");
            linearGradient.setAttribute('id', 'gradient');
            var stop1 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
            stop1.setAttribute('stop-color', '#6E4AE2');
            stop1.setAttribute('offset', '0%');
            linearGradient.appendChild(stop1);
            var stop2 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
            stop2.setAttribute('stop-color', '#78F8EC');
            stop2.setAttribute('offset', '100%');
            linearGradient.appendChild(stop2);
            var linearGradientBackground = document.createElementNS("http://www.w3.org/2000/svg", "linearGradient");
            linearGradientBackground.setAttribute('id', 'gradient-background');
            var stop1 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
            stop1.setAttribute('stop-color', 'rgba(0, 0, 0, 0.2)');
            stop1.setAttribute('offset', '0%');
            linearGradientBackground.appendChild(stop1);
            var stop2 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
            stop2.setAttribute('stop-color', 'rgba(0, 0, 0, 0.05)');
            stop2.setAttribute('offset', '100%');
            linearGradientBackground.appendChild(stop2);
            defs.appendChild(linearGradient);
            defs.appendChild(linearGradientBackground);
            this.svg.appendChild(defs);
            this.defs = defs;
        };

        Dial.prototype.createSlice = function() {
            var slice = document.createElementNS("http://www.w3.org/2000/svg", "path");
            slice.setAttribute('fill', 'none');
            slice.setAttribute('stroke', 'url(#gradient)');
            slice.setAttribute('stroke-width', this.strokeWidth);
            slice.setAttribute('transform', 'translate(' + this.strokeWidth / 2 + ',' + this.strokeWidth / 2 + ')');
            slice.setAttribute('class', 'animate-draw');
            this.svg.appendChild(slice);
            this.slice = slice;
        };

        Dial.prototype.createOverlay = function() {
            var r = this.size - (this.size / 2) - this.strokeWidth / 2;
            var circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            circle.setAttribute('cx', this.size / 2);
            circle.setAttribute('cy', this.size / 2);
            circle.setAttribute('r', r);
            circle.setAttribute('fill', 'url(#gradient-background)');
            this.svg.appendChild(circle);
            this.overlay = circle;
        };

        Dial.prototype.createText = function() {
            var fontSize = this.size / 3.5;
            var text = document.createElementNS("http://www.w3.org/2000/svg", "text");
            text.setAttribute('x', (this.size / 2) + fontSize / 7.5);
            text.setAttribute('y', (this.size / 2) + fontSize / 4);
            text.setAttribute('color', 'black');
            text.setAttribute('font-family', 'Century Gothic, Lato');
            text.setAttribute('font-size', fontSize);
            text.setAttribute('background-color', 'transparent');
            text.setAttribute('text-anchor', 'middle');
            var tspanSize = fontSize / 3;
            text.innerHTML = 0 + '<tspan font-size="' + tspanSize + '" dy="' + -tspanSize * 1.2 + '">%</tspan>';
            this.svg.appendChild(text);
            this.text = text;
        };

        Dial.prototype.createArrow = function() {
            var arrowSize = this.size / 10;
            var arrowYOffset, m;
            if(this.direction === 'up') {
                arrowYOffset = arrowSize / 2;
                m = -1;
            }
            else if(this.direction === 'down') {
                arrowYOffset = 0;
                m = 1;
            }
            var arrowPosX = ((this.size / 2) - arrowSize / 2);
            var arrowPosY = (this.size - this.size / 3) + arrowYOffset;
            var arrowDOffset =  m * (arrowSize / 1.5);
            var arrow = document.createElementNS("http://www.w3.org/2000/svg", "path");
            arrow.setAttribute('d', 'M 0 0 ' + arrowSize + ' 0 ' + arrowSize / 2 + ' ' + arrowDOffset + ' 0 0 Z');
            arrow.setAttribute('fill', '#97F8F0');
            arrow.setAttribute('opacity', '0.6');
            arrow.setAttribute('transform', 'translate(' + arrowPosX + ',' + arrowPosY + ')');
            this.svg.appendChild(arrow);
            this.arrow = arrow;
        };

        Dial.prototype.animateStart = function() {
            var v = 0;
            var self = this;
            var intervalOne = setInterval(function() {
                var p = +(v / self.value).toFixed(2);
                var a = (p < 0.95) ? 2 - (2 * p) : 0.05;
                v += a;
                // Stop
                if(v >= +self.value) {
                    v = self.value;
                    clearInterval(intervalOne);
                }
                self.setValue(v);
            }, 10);
        };

        Dial.prototype.animateReset = function() {
            this.setValue(0);
        };

        Dial.prototype.polarToCartesian = function(centerX, centerY, radius, angleInDegrees) {
          var angleInRadians = (angleInDegrees-90) * Math.PI / 180.0;
          return {
            x: centerX + (radius * Math.cos(angleInRadians)),
            y: centerY + (radius * Math.sin(angleInRadians))
          };
        }

        Dial.prototype.describeArc = function(x, y, radius, startAngle, endAngle){
            var start = this.polarToCartesian(x, y, radius, endAngle);
            var end = this.polarToCartesian(x, y, radius, startAngle);
            var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
            var d = [
                "M", start.x, start.y, 
                "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
            ].join(" ");
            return d;       
        }

        Dial.prototype.setValue = function(value) {	
            var c = (value / 100) * 360;
            if(c === 360)
              c = 359.99;
            var xy = this.size / 2 - this.strokeWidth / 2;
            var d = this.describeArc(xy, xy, xy, 180, 180 + c);
            this.slice.setAttribute('d', d);
            var tspanSize = (this.size / 3.5) / 3;
            this.text.innerHTML = Math.floor(value) + '<tspan font-size="' + tspanSize + '" dy="' + -tspanSize * 1.2 + '">%</tspan>';
        };

        //
        // Usage
        //

        var containers = document.getElementsByClassName("chart");
        var dial = new Dial(containers[0]);
        dial.animateStart();
      },
      resizeCard(){
        if(this.gridApi)
          this.gridApi.sizeColumnsToFit();
      },
      showMyConfetti(){
        var myCanvas = document.getElementById('canvas');
        var self = this;
        var myConfetti = confetti.create(myCanvas, {
          resize: true,
          useWorker: true
        });

        var duration = 5 * 1000;
        var animationEnd = Date.now() + duration;
        var defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

        function randomInRange(min, max) {
          return Math.random() * (max - min) + min;
        }

        var interval = setInterval(function() {
          var timeLeft = animationEnd - Date.now();

          if (timeLeft <= 0) {
            return clearInterval(interval);
          }

          var particleCount = 50 * (timeLeft / duration);
          // since particles fall down, start a bit higher than random
            confetti(Object.assign({}, defaults, { particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } }));
            confetti(Object.assign({}, defaults, { particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } }));
          }, 250);

          // myConfetti({
          //   particleCount: 100,
          //   spread: 160,
          //   origin: { y: 0.6 }
          //   // any other options from the global
          //   // confetti function
          // });

          setTimeout(() => {
            confetti.reset();
          }, 2000);
      },
      checkforArray(file){
        var self = this;
        if(file){
          var uploadedFile = []
          if(file.includes(",")){
            uploadedFile = file.split(",");
          }
          else{
            uploadedFile.push(file);
          }
          return uploadedFile
        }
        else{
          return uploadedFile
        }
      },
      fileName(file){
        var self = this;
        if(file){
          var size = file.length;
          var firstIndex = file.split("_")[0].length +1;
          var fileName = file.substring(firstIndex,size);
          return fileName
        }
        else{
          return file
        }
      },
      downloadFile(file){
        var self = this;
        window.open(file,"_blank");
      },
    },
    mounted(){
      var self = this;
    },
    updated(){
      this.gridApi = this.gridOptions.api;
      this.resizeCard();
    }
  };
</script>

<style lang="scss">
  @import "@/digicampus/assets/main-digi.scss";

  .resizequillimage{
    z-index: 2;
    
    img{
      padding: 10px;
      max-width: 15vw;
      transition: 500ms ease-in-out;
    }
    img::after{
      width: 100%;
      height: 100%;
      z-index: 1;
    }
  
    &:hover{
      img{
        width: 100%;
        height: 100%;
        max-width: 75vw;
      }
      
      p img{
        width: 100%;
        height: 100%;
        max-width: 75vw;
      }
    }
  }
  #review-answer {
    height: 100px;
  }

  .final-result.fail {
    font-size: 2.5em;
    color: red;
  }

  .final-result.pass {
    font-size: 2.5em;
    color: green;
  }

  .vs-button-light.vs-button-border:hover, .vs-button-light.vs-button-flat:hover {
    background: rgba(245, 245, 245, 0.3) !important;
  }

  .marks {
    font-size: 1.5em;
  }

  .overflowCardScroll {
    overflow-x: hidden !important;
    overflow-y: scroll !important;
  }

  .contentCards {
    margin: auto;
  }

  #quiz-result-card {
    #digiResultAgGridTable.ag-grid-table{
      height: 300px !important;
    }

    #next-task-arrow {
      position: sticky !important;
      z-index: 99999;
      width: 50px;
      margin-bottom: 5px;
      margin-right: 0px !important;
      float: right;
    }

    #next-task-arrow:hover {
      width: 53px;
      cursor: pointer;
    }

    #next-task-arrow:active {
      width: 50px;
      cursor: pointer;
      opacity: 0.8;
    }

    #help-btn { 
      z-index: 50000;
      margin-bottom: 5px;
      margin-left: 10px;
      &.vs-button.large .vs-button--icon {
        font-size: 1.75rem !important;
      }
      bottom: 3% !important;
    }
  }

  @media screen and (max-width: 900px) {
    #quiz-result-card {
      #next-task-arrow {
        width: 35px;
        position: sticky !important;
        margin-bottom: 2px;
        margin-right: 0px !important;
      }

      #next-task-arrow:hover {
        width: 38px;
        cursor: pointer;
      }

      #next-task-arrow:active {
        width: 35px;
        cursor: pointer;
        opacity: 0.8;
      }
    }
  }

  #question-text-div {
    * {
      color: black !important;
    }
  }
  .vs-checkbox{
    padding: 5px !important;
  }


.button-center-bottom{
  position:absolute !important;
  width:260px !important;
  background: rgb(43,55,43) !important;
  background: linear-gradient(266deg, rgba(43,55,43,1) 0%, rgba(68,198,70,1) 78%) !important;
  &:hover{
    cursor: pointer;
  }
  bottom: 0px !important;
}

.next_btns__container {
  .next_btns {
    .vs-button--text {
      text-transform: uppercase !important;
    }

    .vs-icon {
      font-size: 1.2rem !important;
    }

    width: 100% !important;
  }

  #nexttask-btn {
    width: 13% !important;
    border-radius: 25px !important;
    background-image: linear-gradient(#1c80c4,  #2367a7) !important;
  }

  #completetask-btn {
    width: 225px !important;
    border-radius: 25px !important;
    background-image: linear-gradient(266deg, rgba(43,55,43,1) 0%, rgba(68,198,70,1) 78%) !important;
  }

  @media screen and (max-width: 900px) {
    #nexttask-btn {
      width: 45% !important;
    }

    #completetask-btn {
      width: 45% !important;
    }
  }

  @media screen and (max-width: 700px) {
    #nexttask-btn {
      width: 50% !important;
    }

    #completetask-btn {
      width: 50% !important;
    }
  }
}

.container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  overflow: inherit;
}

#canvas{
  width: 100%;
  height: 100%;
}

.draggable-images-quiz-result{
  display: flex;
  overflow-x: auto;
  width: 100%;

  div{
    margin-right: 4px;
  }
}

#quiz-results-view {
  .vs-checkbox--check {
    .vs-checkbox--icon {
      font-size: 16px !important;
    }
  }

  .vx-card__body {
    padding: 1.5rem !important;
  }
}

.free-text-answer{
  .con-vs-card{
    height: max-content !important;
    padding: 15px;
  }
}
</style>
